/// IMPORTS
import {
  WorkspacePromptGetQuery,
  WorkspacePromptGetResponse,
  WorkspacePromptPostBody,
  WorkspacePromptPostResponse,
  WorkspacePromptPutBody,
  WorkspacePromptPutResponse,
  WorkspacePromptDeleteQuery,
  WorkspacePromptDeleteResponse,
  WorkspacePromptsGetQuery,
  WorkspacePromptsGetResponse,
  WorkspacePromptPostsBody,
  WorkspacePromptPostsResponse,
  WorkspacePromptPutsBody,
  WorkspacePromptPutsResponse,
  WorkspacePromptDeletesQuery,
  WorkspacePromptDeletesResponse,
  WorkspacePromptOrderPutBody,
  WorkspacePromptOrderPutResponse,
} from 'generatedInterfaces';
import { PromptsOfflineEndpoint } from 'src/app/classes/offlineEndpoints/promptsOfflineEndpoint';
import { PromptsOnlineEndpoint } from 'src/app/classes/onlineEndpoints/promptsOnlineEndpoint';
import { HttpErrorResponse } from '@angular/common/http';
import { Workspace } from '../workspace';
import { throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs/internal/Observable';

export class PromptsModel {
  /// PROPERTIES
  private onlineEndpoint: PromptsOnlineEndpoint = new PromptsOnlineEndpoint();
  private offlineEndpoint: PromptsOfflineEndpoint =
    new PromptsOfflineEndpoint();

  /// CUSTOM PROPERTIES

  ///

  constructor() {
    this.customConstructor();
  }

  customConstructor() {
    /// CUSTOM CONSTRUCTOR CONTENT
    ///
  }

  /// METHODS

  // workspacePromptOrderPut
  public changeOrder(
    obj: WorkspacePromptOrderPutBody
  ): Observable<WorkspacePromptOrderPutResponse> {
    return this.onlineEndpoint.changeOrder(obj).pipe(
      map(
        (response: WorkspacePromptOrderPutResponse) => {
          return response;
        },
        catchError((err: HttpErrorResponse) => {
          return throwError(() => err);
        })
      )
    );
  }

  // workspacePromptDeletes
  public deletesMany(
    obj: WorkspacePromptDeletesQuery
  ): Observable<WorkspacePromptDeletesResponse> {
    return this.onlineEndpoint.deletesMany(obj).pipe(
      map(
        (response: WorkspacePromptDeletesResponse) => {
          const objs = obj.ids.map((val) => {
            return { id: val };
          });
          for (let obj of objs)
            this.offlineEndpoint.delete(obj as Workspace['prompts'][0]);
          return response;
        },
        catchError((err: HttpErrorResponse) => {
          return throwError(() => err);
        })
      )
    );
  }

  // workspacePromptPuts
  public putsMany(
    obj: WorkspacePromptPutsBody
  ): Observable<WorkspacePromptPutsResponse> {
    return this.onlineEndpoint.putsMany(obj).pipe(
      map(
        (response: WorkspacePromptPutsResponse) => {
          const objs = obj.bodies;
          for (let obj of objs)
            this.offlineEndpoint.pushOrUpdate(obj as Workspace['prompts'][0]);
          return response;
        },
        catchError((err: HttpErrorResponse) => {
          return throwError(() => err);
        })
      )
    );
  }

  // workspacePromptPosts
  public postsMany(
    obj: WorkspacePromptPostsBody
  ): Observable<WorkspacePromptPostsResponse> {
    return this.onlineEndpoint.postsMany(obj).pipe(
      map(
        (response: WorkspacePromptPostsResponse) => {
          const objs = obj.bodies;
          for (let obj of objs)
            this.offlineEndpoint.pushOrUpdate(obj as Workspace['prompts'][0]);
          return response;
        },
        catchError((err: HttpErrorResponse) => {
          return throwError(() => err);
        })
      )
    );
  }

  // workspacePromptsGet
  public getMany(obj: WorkspacePromptsGetQuery): {
    local: Workspace['prompts'];
    promise: Observable<WorkspacePromptsGetResponse>;
  } {
    return {
      local: this.offlineEndpoint.getMany(obj).filter((item) => {
        for (let key of Object.keys(obj)) {
          if ((<any>item)[key] != (<any>obj)[key]) {
            return false;
          }
        }
        return true;
      }),
      promise: this.onlineEndpoint.getMany(obj).pipe(
        map(
          (response: WorkspacePromptsGetResponse) => {
            let mains = response.main;
            if (mains)
              this.offlineEndpoint.setEntities(mains as Workspace['prompts']);

            return response;
          },
          catchError((err: HttpErrorResponse) => {
            return throwError(() => err);
          })
        )
      ),
    };
  }

  // workspacePromptDelete
  public deleteOne(
    obj: WorkspacePromptDeleteQuery
  ): Observable<WorkspacePromptDeleteResponse> {
    return this.onlineEndpoint.deleteOne(obj).pipe(
      map(
        (response: WorkspacePromptDeleteResponse) => {
          this.offlineEndpoint.delete(obj as Workspace['prompts'][0]);
          return response;
        },
        catchError((err: HttpErrorResponse) => {
          return throwError(() => err);
        })
      )
    );
  }

  // workspacePromptPut
  public putOne(
    obj: WorkspacePromptPutBody
  ): Observable<WorkspacePromptPutResponse> {
    return this.onlineEndpoint.putOne(obj).pipe(
      map(
        (response: WorkspacePromptPutResponse) => {
          this.offlineEndpoint.pushOrUpdate(obj as Workspace['prompts'][0]);
          return response;
        },
        catchError((err: HttpErrorResponse) => {
          return throwError(() => err);
        })
      )
    );
  }

  // workspacePromptPost
  public postOne(
    obj: WorkspacePromptPostBody
  ): Observable<WorkspacePromptPostResponse> {
    return this.onlineEndpoint.postOne(obj).pipe(
      map(
        (response: WorkspacePromptPostResponse) => {
          this.offlineEndpoint.pushOrUpdate(obj as Workspace['prompts'][0]);
          return response;
        },
        catchError((err: HttpErrorResponse) => {
          return throwError(() => err);
        })
      )
    );
  }

  // workspacePromptGet
  public getOne(obj: WorkspacePromptGetQuery): {
    local: Workspace['prompts'][0];
    promise: Observable<WorkspacePromptGetResponse>;
  } {
    return {
      local: this.offlineEndpoint.getOne(obj),
      promise: this.onlineEndpoint.getOne(obj).pipe(
        map(
          (response: WorkspacePromptGetResponse) => {
            this.offlineEndpoint.pushOrUpdate(
              response.main as Workspace['prompts'][0]
            );

            return response;
          },
          catchError((err: HttpErrorResponse) => {
            return throwError(() => err);
          })
        )
      ),
    };
  }

  /// CUSTOM METHODS

  ///
}
